import { render, staticRenderFns } from "./AddChildren.vue?vue&type=template&id=c6f7b8be&"
import script from "./AddChildren.vue?vue&type=script&lang=js&"
export * from "./AddChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports